import React, { useState, useEffect } from "react";
import { useRouter } from "../util/router";

import AnalyticContents from "../components/analytics/AnalyticContents";
import NotFoundPage from "../components/general/NotFound";
import { useUser } from "../util/user";

function AnalyticsPage() {
  const [hasAccess, setHasAccess] = useState(false);
  const router = useRouter();
  const userObj = useUser();

  useEffect(() => {
    // User is authenticated
    if (userObj != null) {
      // User has access to this page
      if (userObj.roles != null && userObj.roles.includes("analytics:_view"))
        setHasAccess(true);
    }
    else
      router.push("/solar/logout");

  }, [userObj]);

  return hasAccess ? <AnalyticContents /> : <NotFoundPage />;
}

export default AnalyticsPage;
